import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import gridLabels from "../Labels/GridLabels";
import REPORTS_PRINT_COLUMNS from "./ReportsPrintTableColumn";
import ReportsPrintModalEditor from "./ReportsPrintModalEditor";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/loading";
import {
  getAllUnit,
  updateUnit,
  deleteUnit,
} from "../../store/njesiRaportuese";
import { Box } from "@mui/system";
import RowButtonIcon from "../UI/RowButtonIcon";
import EditIcon from "@mui/icons-material/Edit";
import ButtonAdd from "../UI/ButtonAdd";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import DialogDelete from "../UI/DialogDelete";
import SearchInput from "../UI/SearchInput";
import { DeleteOutline } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import useReportStore from "../../store/zustandStore/reportZs";
import RowButtonLabel from "../UI/RowButtonLabel";

const ReportsPrintTable = () => {
  const dispatch = useDispatch();
  const {
    njesiRaportuese,
    totalElements,
    totalPages,
    size,
    currentPage,
    searchValueCurrent,
  } = useSelector((state) => state.njesiRaportuese);

  const { reportsZs, fetchReportsZs, deleteReportZs } = useReportStore();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [selectRowId, setSelectRowId] = React.useState("");
  const [selectRowItem, setSelectRowItem] = React.useState({});
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [report, setReport] = React.useState({});
  const [updateReport, setUpdateReport] = React.useState({});
  const [dataColumns, setDataColumns] = React.useState(REPORTS_PRINT_COLUMNS);
  const [page, setPage] = React.useState(currentPage);
  const searchState = React.useRef("");
  const [searchValueServer, setSearchValueServer] =
    React.useState(searchValueCurrent);
  const [isExporting, setIsExporting] = React.useState(false);
  const navigate = useNavigate();

  const initialReport = {
    id: "",
    title: "",
  };

  const handleChangePage = (event, newPage) => {
    setPage(event);
  };

  const searchItems = (e) => {
    const searchValue = e.target.value;
    if (searchValue !== "") {
      searchState.current.value = searchValue;
      let filterTimeout;
      filterTimeout = setTimeout(() => {
        setSearchValueServer(searchState.current.value);
      }, 1000);
    } else {
      setSearchValueServer("");
      dispatch(getAllUnit({ page: page, searchValue: "" }));
    }
  };

  React.useEffect(() => {
    getAllData();
  }, [dispatch, page, searchValueServer]);

  React.useEffect(() => {
    // fetchForminputesSubmissionsZs();
    fetchReportsZs();
  }, []);

  const getAllData = () => {
    dispatch(setLoading(true));
    dispatch(getAllUnit({ page: page, searchValue: searchValueServer }))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setReport(e.row);
    setOpen(true);
  };

  const addNew = () => {
    setIsStatusNew(true);
    setReport(initialReport);
    setOpen(true);
  };

  const handleClickDelete = (e) => {
    setSelectRowId(e.row.id);
    setSelectRowItem(e.row);
    let copyOfObject = { ...e.row };
    setUpdateReport(copyOfObject);
    setStateDialogDelete(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleDeleteReport = (e) => {
    deleteReportZs(report.id);
    setStateDialogDelete(false);
  };

  const openChapter = () => {
    navigate("/reports-print/chapter-editor", {
      state: { reportId: "", reportTitle: "test" },
    });
  };

  const openChapterSelected = (e) => {
    // setIsStatusNew(false);
    // setReport(e.row);
    navigate("/reports-print/chapters", {
      state: {
        reportId: e.row?.id,
        reportTitle: e.row?.title,
        year: e.row?.year,
      },
    });
    // setOpen(true);
  };

  function CustomToolbar() {
    return (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            py: "18px",
            px: "9px",
            alignItems: "center",
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              direction: "column",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <SearchInput
              onChange={searchItems}
              inputRef={searchState}
              defaultValue={searchState.current.value}
            ></SearchInput>
          </Box>
          <ButtonAdd onClick={addNew} />
        </Box>
      </Box>
    );
  }
  return (
    <div style={{ height: 700, width: "100%" }}>
      <DataGrid
        labelRowsPerPage="Artikuj per faqe"
        disableSelectionOnClick
        onRowDoubleClick={openChapterSelected}
        columns={[
          ...dataColumns,
          {
            headerName: "",
            overflow: "hidden",
            field: "action",
            editable: false,
            flex: 1,
            justifyContent: "flex-end",
            disableClickEventBubbling: true,
            align: "right",
            background: "red",
            headers: false,
            renderHeader: () => {},
            renderCell: (params) => (
              <BoxRowButtonsIcon>
                <RowButtonLabel
                  onClick={(event) => {
                    openChapterSelected(params);
                  }}
                  startIcon={<FolderOpenIcon />}
                >
                  Kapituj
                </RowButtonLabel>
                <RowButtonIcon
                  onClick={(event) => {
                    currentlySelected(params);
                  }}
                >
                  <EditIcon />
                </RowButtonIcon>
                <RowButtonIcon
                  onClick={(event) => {
                    // currentlySelected(params);
                    setReport(params?.row);
                    setStateDialogDelete(true);
                  }}
                >
                  <DeleteOutline color="error" />
                </RowButtonIcon>
              </BoxRowButtonsIcon>
            ),
          },
        ]}
        // rows={njesiRaportuese ? njesiRaportuese : []}
        rows={reportsZs ? reportsZs : reportsZs}
        density="comfortable"
        editMode="row"
        disableColumnMenu
        localeText={gridLabels}
        componentsProps={{
          pagination: {
            labelRowsPerPage: "Rreshta për Faqe",
            showLastButton: true,
            showFirstButton: true,
          },
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        // onCellClick={currentlySelected}
        filterModel={filterModel}
        onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
        page={page}
        onPageChange={handleChangePage}
        // count={totalPages}
        count={totalPages}
        // rowCount={totalElements}
        rowCount={1}
        pageSize={size > 100 ? 100 : size}
        pagination
        paginationMode="server"
      />
      {/* <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteNjesiRaportuese}
        valueswitch={
          selectRowItem?.status === "ACTIVE"
            ? "INAKTIVE"
            : selectRowItem?.status === "INACTIVE"
            ? "AKTIVE"
            : ""
        }
      /> */}
      <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteReport}
        description="Jeni të sigurt që doni ta fshini këtë Raport? "
      />
      <ReportsPrintModalEditor
        open={open}
        onClose={handleClose}
        formname="Raport"
        isstatusnew={isStatusNew ? 1 : 0}
        data={report}
      ></ReportsPrintModalEditor>
    </div>
  );
};

export default ReportsPrintTable;
